<template>
	<div class="container-xl px-4">
		<div class="row justify-content-center">
			<div class="col-xl-5 col-lg-6 col-md-8 col-sm-11">
				<!-- Basic login form-->
				<div class="card shadow-lg border-0 rounded-lg my-5 login-company">
					<div class="card-header p-2 text-center">
						<!-- my-4 -->
						<h1 class="text-uppercase font-weight-light my-4">
							{{ $t('login.connect') }}
						</h1>
					</div>
					<hr class="my-0" />
					<div class="card-body p-5">
						<div class="alert alert-danger" v-if="errorStatus" role="alert">
							{{ $t('error.login') }}
						</div>
						<div class="alert alert-danger" v-if="connectIssue" role="alert">
							{{ $t('error.connect') }}
						</div>
						<!-- Login form-->
						<form action="#" @submit.prevent="login">
							<!-- Form Group (email address)-->
							<div class="form-group">
								<label class="small mb-1" for="username">
									{{ $t('login.username') }}
								</label>
								<input class="form-control form-control-solid" id="username" name="username" type="text" required="required" :placeholder="`${ $t('login.username') }`" v-model="username" autocomplete="off" />
							</div>
							<!-- Form Group (password)-->
							<div class="form-group">
								<label class="small mb-1" for="password">
									{{ $t('login.password') }}
								</label>
								<input class="form-control form-control-solid" id="password" name="password" type="password" required="required" :placeholder="`${ $t('login.password') }`" v-model="password" autocomplete="off" />
							</div>
							<div class="form-group">
								<div class="small">
									<!-- <router-link :to="{ name: 'recover'}">
										{{ $t('login.recover.accountRecov') }}
									</router-link> -->
								</div>
							</div>
							<!-- Form Group (remember password checkbox)-->
							<div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
								<div class="custom-control custom-checkbox">
									<input class="custom-control-input" id="rememberPasswordCheck" type="checkbox" />
										<label class="custom-control-label" for="rememberPasswordCheck">
											{{ $t('login.rememberme') }}
										</label>
								</div>
								<!-- Form Group (login box)-->
								<div>
									<!--a.small(href='auth-password-basic.html') Forgot Password?-->
									<!-- <button id="loginButton" type="button" class="btn-sm btn-success" >
										<fa icon="sign-in"/> {{ $t('login.connect', 1) }}
									</button> -->
									<!-- <input class="btn btn-warning mr-1 btn-sm" id="loginButton" type="submit" :value="$t('login.connect')"> -->

									<b-button id="loginButton" class="btn btn-success btn-sm"
											@click="login">
										<fa icon="sign-in"/>
											{{$t('login.label')}}
									</b-button>
									
								</div>
							</div>
						</form>
					</div>
					<!--<hr class="my-0" />
					<div class="card-body px-5 py-4">
						<input class="btn btn-warning" id="loginButtonG" @click="connectWithGoogle" :value="$t('login.connectWithGoogle')" />
					</div> -->
					<!-- <hr class="my-0" />
					<div class="card-body px-5 py-4">
						<div class="small text-center">
							<router-link :to="{ name: 'register'}" d>
								{{ $t('login.register.signUp') }}
							</router-link>
						</div>
					</div> -->

				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'login',
		data() {
			return {
				username: '',
				password: '',
				errorStatus: false,
				connectIssue: false,
				mfaActivated: this.$store.getters.mfaActivated
			}
		},
		methods: {
			async connectWithGoogle(event){
				event.preventDefault()            
				let url = this.$router.resolve({ name: 'oauth2view' }).href            
				let redirectUrl = location.origin + url + '?token='
				window.location.href = (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + "/oauth/authenticate/google?callback=" + redirectUrl
			},
			async login() {
				this.$store.dispatch('loading')
				document.getElementById('loginButton').disabled = true;
				try {
					await this.$store.dispatch('login', {
						username: this.username,
						password: this.password
					})
					.then((res) => {
						if(this.$store.getters.mfaEnabled && this.mfaActivated) {
							this.$router.push({
								name: 'otpVerifier'
							})
							.catch((error) => {
								console.log(error)
							})
						} 
						else {
							// this.$router.push({name: 'home'})
							this.$router.push({name: 'dashboard'})
							// window.location.reload();
							// this.$router.go(0);
							// this.$router.go(-1)
							.catch((error) => {
								console.log(error)
							})
						}
					})
					.catch((error) => {
						document.getElementById('loginButton').disabled = false;
						if(error) {
							if(error.status)
								this.errorStatus = [401, 403].includes(error.status)
							else
								this.connectIssue = true
						} 
						else
							console.log(error)
					})
				} 
				catch(exception) {
					document.getElementById('loginButton').disabled = false;
					console.log(exception)
				}
				this.$store.dispatch('unloading')
			}
		}
	}
</script>